//This is for POS Print

import React from "react";
import "./stylePos.css";
import { currency } from "../../../MUI_components/currencyFormatterTag";
import { company } from "titum-custom/details";
import BillHeader from "Components/Print/billHeaderPos";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";

const PrintBill = React.forwardRef((props, ref) => {
  const { submittedData,pageStatus } = props;
  const { stockHistories, customer } = submittedData;

  var currentDate = new Date();
  var today = currentDate.toLocaleString();

    const handleLineTotal = (qty, price, discountPer, discountAmount) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    return lineTotalAmount;
  };

  const billCredit = submittedData.totalAmount > submittedData.receivedAmount
                       ? parseFloat(submittedData.totalAmount) - parseFloat(submittedData.receivedAmount)
                       : 0;
  return (

    <div className ref={ref}>

      <div className="billBody" >
        <BillHeader />
        <div align="center"><strong>{`INVOICE ${pageStatus.recalled ? "Re-Printed" : ""} - ${submittedData.code ?? props.code}`}</strong></div>

        <div className="text-center " style={{ fontSize: 12 }}>
          <div style={{ textAlign: "center", fontSize: 12 }}>{company.address}</div>
          <div style={{ textAlign: "center", fontSize: 12 }} >TEL: {company.phone} / {company.phone2} </div>
        </div>

        <div style={{ borderTop: "1px solid #000", marginBottom: 2 }} ></div>

        <div >
          <div className="flex" >
            <strong style={{ fontSize: 11 }}> INVOICE: </strong> &nbsp;
            <strong style={{ fontSize: 11 }}>{submittedData.code ? submittedData.code : props.invoiceCode}</strong>
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 11 }}>CUSTOMER: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}> {customer ? customer.firstName : "" }</strong>
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 11 }}>DATE: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}> {pageStatus.recalled ?  submittedData.date :  today }</strong>
          </div>
        </div>

        <div style={{ borderBottom: "1px solid #000", marginTop: 2 }}></div>

        <table >
          <thead>
            <tr style={{ borderBottom: "1px solid #000" }}>
              <th>#</th>
              <th width="80%">DEC</th>
              <th align="right" style={{ paddingLeft: 10 }}>QTY</th>
              <th align="right" style={{ paddingLeft: 10 }}>PRI </th>
              <th align="right" style={{ paddingLeft: 10 }}>D.%</th>
              <th align="right" style={{ paddingLeft: 10 }}> D.Rs</th>
              <th align="right" style={{ paddingLeft: 10 }}>AMT</th>
            </tr>
          </thead>

          <tbody>
            {stockHistories
              .filter(i => i.quantity > 0)
              .map((row, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td> {index + 1}.</td>
                    <td colSpan="5">
                    {row.name ? row.name : row.itemMaster.name }

                    </td>
                  </tr>
                  <tr>
                    <td align="right" colSpan="3">{parseFloat(row.quantity)}</td>
                    <td align="center" style={{ paddingLeft: 10 }}>{row.retailPrice}</td>
                    <td align="center" style={{ paddingLeft: 10 }}>{row.discountPercentage}</td>
                    <td align="center" style={{ paddingLeft: 10 }}>{row.discountAmount}</td>
                    <td align="right">
                      <strong>{currency(handleLineTotal(
                        row.quantity,
                        row.retailPrice,
                        row.discountPercentage,
                        row.discountAmount
                      ))}</strong>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>

        </table>

        <div style={{ borderBottom: "1px solid #000" }}></div>

        <div className="flex-print  mb  justify-content-spaceBetween">
          <div>
            <strong>{COLUMNS_NAME.SUB_TOTAL} : </strong>
          </div>

          <div>
            <strong > {currency(submittedData.subTotalAmount)}</strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween"  >
          <div>
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.DISCOUNT_TOTAL}:</strong>
          </div>
          <div>
            <strong style={{ fontSize: 11 }}>{currency(submittedData.discountTotal)}</strong>
          </div>
        </div>
        <div
          className="flex-print  mb  justify-content-spaceBetween"
          style={{ borderTop: "1px solid #000" }}
        >
          <strong style={{ fontSize: 16 }}>{COLUMNS_NAME.LAST_TOTAL}</strong>

          <strong style={{ fontSize: 16 }}>{currency(submittedData.totalAmount)}</strong>
        </div>

        <div className="flex-print  justify-content-spaceBetween">
          <div>
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.PAYID_AMOUNT} :</strong>
          </div>

          <div>
            <strong style={{ fontSize: 11 }}>{currency(submittedData.paidAmount)}
            </strong>
          </div>
        </div>

        <div className="flex-print  justify-content-spaceBetween" >
          <div>
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.BALANCE_GIVEN} :</strong>
          </div>
          <div>
            <strong style={{ fontSize: 11 }}>
            {submittedData.receivedAmount >= submittedData.totalAmount ? `${currency(submittedData.receivedAmount - submittedData.totalAmount)}` : "0.00"}
            </strong>
          </div>
        </div>
        
        <div className="flex-print  justify-content-spaceBetween" >
          <div>
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.TOTAL_OUTSTANDING} :</strong>
          </div>

          <div>
            <strong>
             {/* ---Adding invoice credit with old credit amount---   */}

             {pageStatus.recalled ? currency(customer?.creditAmount) : 
     submittedData.totalAmount > submittedData.receivedAmount ?
    (parseFloat(submittedData.totalAmount)  - parseFloat(submittedData.receivedAmount) ) + parseFloat(customer?.creditAmount) + ".00" : "0.00"
    }
              
            </strong>
          
          </div>
        </div>


        <div style={{ borderBottom: "1px solid #000" }}></div>

        {/* PRINT WITH BIZX FOOTER */}
        <small className="mt  text-center" >

          <div style={{ fontSize: 11 }} >
            THANK YOU COME AGAIN <br />
            SOLUTION BY TITUM (PVT) LTD <br />
            {TitumDetails.WEB} | {TitumDetails.EMAIL_ID}  {TitumDetails.PHONE_NO}

          </div>
        </small>
      </div>

    </div>
  )
});

export default PrintBill;

// mt-margin top mb-marigin bottom
// justify-content-spaceBetween - vertical space
// #000 - black